import { genreList } from '@/mocks/anime';

const colorMap: Record<string, { bg: string; icon: string; dot: string }> = {
  primary: { bg: 'bg-primary-100 text-primary-700', icon: 'text-primary-500', dot: 'bg-primary-500' },
  secondary: { bg: 'bg-secondary-100 text-secondary-900', icon: 'text-secondary-600', dot: 'bg-secondary-500' },
  accent: { bg: 'bg-accent-100 text-accent-900', icon: 'text-accent-600', dot: 'bg-accent-500' },
};

export default function Categories() {
  return (
    <section className="bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-wider text-secondary-600">
            <i className="ri-grid-fill" /> 主题分类
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">想补哪种类型的番？</h2>
          <p className="mx-auto mt-2 max-w-2xl text-sm text-foreground-700 md:text-base">
            按分类快速定位感兴趣的番剧，每个分类下的作品都配有完整的分集剧情与故事线梳理。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6">
          {genreList.map((g) => {
            const c = colorMap[g.color];
            return (
              <a
                key={g.name}
                href="#episode"
                className="group flex flex-col items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-5 transition-all hover:-translate-y-1 hover:border-background-300"
              >
                <span className={`flex h-12 w-12 items-center justify-center rounded-md text-2xl ${c.bg}`}>
                  <i className={g.icon} />
                </span>
                <span className="text-sm font-semibold text-foreground-900">{g.name}</span>
                <span className={`h-1 w-6 rounded-full ${c.dot} opacity-0 transition-opacity group-hover:opacity-100`} />
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}